import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectTypeDefinitionSaveFailedAction = {
	type: 'SUBJECT_TYPE_DEFINITION_SAVE_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectTypeDefinitionSaveFailedAction => ({
	type: 'SUBJECT_TYPE_DEFINITION_SAVE_FAILED',
	payload,
});
